<style lang="less" scoped>
  .title {
    font-size: 48px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
  .button {
    margin-top: 24px;
  }
</style>

<template lang="pug">
  .time.std-layout
    .header
      header-component(@click-back='redirectBack')
    .content
      .title
        div 훈련하기
    .footer
      button-component.button(
        @click='$router.push({ name: "TrainingNumber" })'
        :text='"스피드 넘버"'
        :icon='"/static/icons/icon-numbers@2x.png"')
      button-component.button(
        @click='$router.push({ name: "TrainingCard" })'
        :text='"스피드 카드"'
        :icon='"/static/icons/icon-cards@2x.png"')
      button-component.button(
        @click='$router.push({ name: "TrainingImage" })'
        :text='"랜덤 이미지"'
        :icon='"/static/icons/icon-images@2x.png"')
</template>

<script>
import HeaderComponent from '@/components/header/back';
import ButtonComponent from '@/components/button';

export default {
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
  },
  components: {
    HeaderComponent,
    ButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/index.vue